<template>
  <div
    role="status"
    aria-busy="true"
    class="font-sans min-h-screen bg-(--ui-primary-50) dark:bg-slate-900"
  >
    <div class="sm:flex min-h-screen animate-pulse">
      <aside
        class="border-r w-80 p-5 hidden lg:flex flex-col justify-between bg-white dark:bg-slate-900"
      >
        <div class="flex-1">
          <div class="flex items-center gap-3 mb-8">
            <USkeleton class="h-10 w-10 rounded-lg" />
            <USkeleton class="h-4 w-32 rounded" />
          </div>
          <div class="space-y-3">
            <USkeleton
              v-for="index in 7"
              :key="index"
              class="h-8 w-full rounded"
            />
          </div>
        </div>
        <USkeleton class="h-8 w-28 rounded" />
      </aside>

      <div class="flex-1 min-w-0">
        <header class="border-b bg-white dark:bg-slate-900 p-2 w-full">
          <div class="max-w-7xl mx-auto flex items-center justify-between">
            <USkeleton class="h-8 w-40 rounded" />
            <div class="flex items-center gap-3">
              <USkeleton class="h-4 w-24 rounded" />
              <USkeleton class="h-8 w-8 rounded-full" />
            </div>
          </div>
        </header>

        <main class="px-4 pb-4 pt-4">
          <div class="mx-auto w-7xl max-w-full">
            <div class="flex gap-2 mb-6">
              <USkeleton class="h-9 w-28 rounded-full" />
              <USkeleton class="h-9 w-28 rounded-full" />
            </div>

            <div class="sm:flex sm:space-x-4 mb-4">
              <USkeleton class="xl:w-[330px] sm:w-96 h-40 rounded-lg mb-4 sm:mb-0" />
              <USkeleton class="flex-1 h-40 rounded-lg" />
            </div>

            <div class="xl:flex lg:space-x-4 mb-4">
              <USkeleton class="xl:w-[330px] h-72 rounded-lg mb-4 xl:mb-0" />
              <div class="sm:grid sm:grid-cols-2 gap-4 flex-1">
                <USkeleton class="h-72 rounded-lg mb-4 sm:mb-0" />
                <USkeleton class="h-72 rounded-lg" />
              </div>
            </div>

            <USkeleton class="w-full h-72 rounded-lg" />
          </div>
        </main>
      </div>
    </div>
    <span class="sr-only">Loading session...</span>
  </div>
</template>
